/**
 * @generated SignedSource<<8020bd0b818e3e65d8321af6674932de>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type ActionItemIntegrationSyncStatus = "CREATING_EXTERNALLY" | "DONE_SYNCING_EXTERNALLY" | "FAILED_TO_SYNC_EXTERNALLY" | "SENDING_UPDATE_EXTERNALLY";
export type IntegrationProvider = "ASANA" | "CLICKUP" | "HUBSPOT_TASK" | "JIRA" | "LINEAR" | "MICROSOFT_TODO" | "MONDAY" | "TRELLO";
export type NoteStreamType = "goalset" | "meeting" | "oneonone" | "personal";
export type UserType = "ADMIN" | "BOT" | "GUEST" | "MEMBER";
import { FragmentRefs } from "relay-runtime";
export type MeetingContainerModalNote_note$data = {
  readonly asanaActionItems: ReadonlyArray<{
    readonly asanablocklink: {
      readonly externalId: string | null;
      readonly id: string;
      readonly project: {
        readonly externalId: string | null;
        readonly id: string;
        readonly name: string;
      };
    } | null;
    readonly blockId: string;
    readonly blockKey: string;
  }>;
  readonly attachments: ReadonlyArray<{
    readonly dimensions: {
      readonly height: number;
      readonly width: number;
    } | null;
    readonly id: string;
    readonly " $fragmentSpreads": FragmentRefs<"AttachmentPreviewAttachment">;
  }>;
  readonly canUnlockNote: boolean;
  readonly collapsedBlockKeys: ReadonlyArray<string>;
  readonly comments: ReadonlyArray<{
    readonly blockKey: string;
    readonly count: number;
    readonly users: ReadonlyArray<{
      readonly fullName: string;
      readonly id: string;
      readonly image: string;
      readonly isExternal: boolean;
    }>;
  }>;
  readonly createdAt: string | null;
  readonly eventEnd: string | null;
  readonly eventGuid: string | null;
  readonly eventStart: string | null;
  readonly externalUsers: ReadonlyArray<{
    readonly __typename: "User";
    readonly email: string;
    readonly firstName: string;
    readonly fullName: string;
    readonly id: string;
    readonly image: string;
    readonly internalAttributes: {
      readonly invitable: boolean;
    } | null;
    readonly isActive: boolean;
    readonly isConfigured: boolean;
    readonly isExternal: boolean;
    readonly isGuest: boolean;
    readonly isTopUser: boolean;
    readonly type: UserType;
  }> | null;
  readonly finished: boolean;
  readonly groupName: string;
  readonly id: string;
  readonly integrationLinkedActionItems: ReadonlyArray<{
    readonly actionItemIntegrationLink: {
      readonly actionItem: {
        readonly id: string;
        readonly key: string;
        readonly originalBlockId: string | null;
      };
      readonly createdAt: string | null;
      readonly id: string;
      readonly integrationData: {
        readonly __typename: "ClickupActionItemIntegrationSpecificDataNode";
        readonly externalTaskId: string;
        readonly listName: string;
        readonly status: string;
        readonly statusColor: string;
      } | {
        readonly __typename: "HubspotTaskActionItemIntegrationSpecificDataNode";
        readonly externalTaskId: string;
        readonly hubspotUrl: string;
      } | {
        readonly __typename: "LinearActionItemIntegrationSpecificDataNode";
        readonly externalIdentifier: string | null;
        readonly linearUser: {
          readonly id: string;
          readonly isConnected: boolean;
          readonly organizationUrlKey: string;
        };
        readonly statusColor: string;
        readonly statusName: string;
        readonly teamName: string;
      } | {
        readonly __typename: "MicrosoftTodoActionItemIntegrationSpecificDataNode";
        readonly externalListId: string;
        readonly externalListName: string;
        readonly externalTaskId: string;
        readonly microsoftTodoUser: {
          readonly isConnected: boolean;
        };
        readonly status: string;
      } | {
        readonly __typename: "MondayActionItemIntegrationSpecificDataNode";
        readonly externalBoardId: string;
        readonly externalBoardName: string;
        readonly externalGroupName: string;
        readonly externalTaskId: string;
        readonly mondayUser: {
          readonly accountSlug: string;
        };
        readonly status: string;
      } | {
        readonly __typename: "TrelloActionItemIntegrationSpecificDataNode";
        readonly boardName: string;
        readonly externalCardId: string | null;
      } | {
        // This will never be '%other', but we need some
        // value in case none of the concrete values match.
        readonly __typename: "%other";
      };
      readonly integrationProvider: IntegrationProvider;
      readonly lastSyncedError: string | null;
      readonly syncStatus: ActionItemIntegrationSyncStatus;
      readonly updatedAt: string | null;
    } | null;
    readonly id: string;
    readonly key: string;
  }>;
  readonly isLocked: boolean;
  readonly linkedActionItems: ReadonlyArray<{
    readonly hasOriginalBlock: boolean;
    readonly originalBlock: {
      readonly key: string;
    } | null;
    readonly originalBlockId: string | null;
  }>;
  readonly noteuserSet: ReadonlyArray<{
    readonly id: string;
    readonly lastSeenAt: string | null;
    readonly user: {
      readonly __typename: "User";
      readonly email: string;
      readonly firstName: string;
      readonly fullName: string;
      readonly id: string;
      readonly image: string;
      readonly internalAttributes: {
        readonly invitable: boolean;
      } | null;
      readonly isActive: boolean;
      readonly isConfigured: boolean;
      readonly isExternal: boolean;
      readonly isGuest: boolean;
      readonly isTopUser: boolean;
      readonly type: UserType;
    };
  }>;
  readonly rawDraftJson: any;
  readonly reactions: string;
  readonly stream: {
    readonly account: {
      readonly id: string;
    };
    readonly id: string;
    readonly isExternal: boolean;
    readonly type: NoteStreamType;
  };
  readonly title: string;
  readonly updatedAt: string | null;
  readonly url: string | null;
  readonly viewerCanEdit: boolean;
  readonly " $fragmentSpreads": FragmentRefs<"AttachmentsRelay_note">;
  readonly " $fragmentType": "MeetingContainerModalNote_note";
};
export type MeetingContainerModalNote_note$key = {
  readonly " $data"?: MeetingContainerModalNote_note$data;
  readonly " $fragmentSpreads": FragmentRefs<"MeetingContainerModalNote_note">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "updatedAt",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdAt",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fullName",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "image",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isExternal",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "height",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "width",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v10 = [
  (v8/*: any*/),
  (v0/*: any*/),
  (v9/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "email",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "firstName",
    "storageKey": null
  },
  (v3/*: any*/),
  (v4/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "isActive",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "isConfigured",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "isGuest",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "isTopUser",
    "storageKey": null
  },
  (v5/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "UserInternalAttributes",
    "kind": "LinkedField",
    "name": "internalAttributes",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "invitable",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
],
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "originalBlockId",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "key",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "externalId",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "externalTaskId",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "statusColor",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isConnected",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "MeetingContainerModalNote_note",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "url",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "eventGuid",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "rawDraftJson",
      "storageKey": null
    },
    (v1/*: any*/),
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "eventStart",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "eventEnd",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "finished",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "collapsedBlockKeys",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isLocked",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "canUnlockNote",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "groupName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "viewerCanEdit",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "NoteCommentsData",
      "kind": "LinkedField",
      "name": "comments",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "blockKey",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "count",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "User",
          "kind": "LinkedField",
          "name": "users",
          "plural": true,
          "selections": [
            (v0/*: any*/),
            (v3/*: any*/),
            (v4/*: any*/),
            (v5/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "reactions",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Attachment",
      "kind": "LinkedField",
      "name": "attachments",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "ImageDimensions",
          "kind": "LinkedField",
          "name": "dimensions",
          "plural": false,
          "selections": [
            (v6/*: any*/),
            (v7/*: any*/)
          ],
          "storageKey": null
        },
        {
          "kind": "InlineDataFragmentSpread",
          "name": "AttachmentPreviewAttachment",
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "filename",
              "storageKey": null
            },
            (v1/*: any*/),
            {
              "alias": "directUrl",
              "args": null,
              "kind": "ScalarField",
              "name": "url",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "size",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "ImageDimensions",
              "kind": "LinkedField",
              "name": "dimensions",
              "plural": false,
              "selections": [
                (v7/*: any*/),
                (v6/*: any*/)
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "filetype",
              "storageKey": null
            }
          ],
          "args": null,
          "argumentDefinitions": []
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "NoteUser",
      "kind": "LinkedField",
      "name": "noteuserSet",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "lastSeenAt",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "User",
          "kind": "LinkedField",
          "name": "user",
          "plural": false,
          "selections": (v10/*: any*/),
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "externalUsers",
      "plural": true,
      "selections": (v10/*: any*/),
      "storageKey": null
    },
    {
      "alias": "linkedActionItems",
      "args": [
        {
          "kind": "Literal",
          "name": "linkedOnly",
          "value": true
        }
      ],
      "concreteType": "NoteBlock",
      "kind": "LinkedField",
      "name": "actionItems",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "hasOriginalBlock",
          "storageKey": null
        },
        (v11/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "NoteBlock",
          "kind": "LinkedField",
          "name": "originalBlock",
          "plural": false,
          "selections": [
            (v12/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": "actionItems(linkedOnly:true)"
    },
    {
      "alias": "asanaActionItems",
      "args": [
        {
          "kind": "Literal",
          "name": "asanaOnly",
          "value": true
        }
      ],
      "concreteType": "NoteBlock",
      "kind": "LinkedField",
      "name": "actionItems",
      "plural": true,
      "selections": [
        {
          "alias": "blockId",
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": "blockKey",
          "args": null,
          "kind": "ScalarField",
          "name": "key",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "AsanaBlockLinkNode",
          "kind": "LinkedField",
          "name": "asanablocklink",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "AsanaProjectNode",
              "kind": "LinkedField",
              "name": "project",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "name",
                  "storageKey": null
                },
                (v13/*: any*/)
              ],
              "storageKey": null
            },
            (v13/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": "actionItems(asanaOnly:true)"
    },
    {
      "alias": "integrationLinkedActionItems",
      "args": [
        {
          "kind": "Literal",
          "name": "integrationConnectedOnly",
          "value": true
        }
      ],
      "concreteType": "NoteBlock",
      "kind": "LinkedField",
      "name": "actionItems",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        (v12/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "ActionItemIntegrationLinkNode",
          "kind": "LinkedField",
          "name": "actionItemIntegrationLink",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "NoteBlock",
              "kind": "LinkedField",
              "name": "actionItem",
              "plural": false,
              "selections": [
                (v11/*: any*/),
                (v0/*: any*/),
                (v12/*: any*/)
              ],
              "storageKey": null
            },
            (v2/*: any*/),
            (v1/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "syncStatus",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "lastSyncedError",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "integrationProvider",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "integrationData",
              "plural": false,
              "selections": [
                {
                  "kind": "InlineFragment",
                  "selections": [
                    (v8/*: any*/),
                    (v14/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "listName",
                      "storageKey": null
                    },
                    (v15/*: any*/),
                    (v16/*: any*/)
                  ],
                  "type": "ClickupActionItemIntegrationSpecificDataNode",
                  "abstractKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": [
                    (v8/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "externalCardId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "boardName",
                      "storageKey": null
                    }
                  ],
                  "type": "TrelloActionItemIntegrationSpecificDataNode",
                  "abstractKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": [
                    (v8/*: any*/),
                    (v14/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "externalGroupName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "externalBoardId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "externalBoardName",
                      "storageKey": null
                    },
                    (v15/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "MondayUserNode",
                      "kind": "LinkedField",
                      "name": "mondayUser",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "accountSlug",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "type": "MondayActionItemIntegrationSpecificDataNode",
                  "abstractKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": [
                    (v8/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "externalIdentifier",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "teamName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "statusName",
                      "storageKey": null
                    },
                    (v16/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "LinearUserNode",
                      "kind": "LinkedField",
                      "name": "linearUser",
                      "plural": false,
                      "selections": [
                        (v0/*: any*/),
                        (v17/*: any*/),
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "organizationUrlKey",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "type": "LinearActionItemIntegrationSpecificDataNode",
                  "abstractKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": [
                    (v8/*: any*/),
                    (v14/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "externalListId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "externalListName",
                      "storageKey": null
                    },
                    (v15/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "MicrosoftTodoUserNode",
                      "kind": "LinkedField",
                      "name": "microsoftTodoUser",
                      "plural": false,
                      "selections": [
                        (v17/*: any*/)
                      ],
                      "storageKey": null
                    }
                  ],
                  "type": "MicrosoftTodoActionItemIntegrationSpecificDataNode",
                  "abstractKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": [
                    (v8/*: any*/),
                    (v14/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "hubspotUrl",
                      "storageKey": null
                    }
                  ],
                  "type": "HubspotTaskActionItemIntegrationSpecificDataNode",
                  "abstractKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "actionItems(integrationConnectedOnly:true)"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "NoteStream",
      "kind": "LinkedField",
      "name": "stream",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        (v9/*: any*/),
        (v5/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "account",
          "plural": false,
          "selections": [
            (v0/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "AttachmentsRelay_note"
    }
  ],
  "type": "Note",
  "abstractKey": null
};
})();

(node as any).hash = "ff8adfb8c96c17b417189c9ddb94e9c8";

export default node;
